import HcpShareDocument from "./HcpShareDocument";
export default HcpShareDocument;
